import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatDate, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CATEGORY, STR_CROPS, STR_CUSTOMER_NAME, STR_CUSTOMER_PHONE, STR_DATE, STR_FULLY_PAID, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_OVERALL_COST, STR_PACKAGING_COST, STR_PARTIALLY_PAID, STR_POST_ITEM, STR_RECEIPT, STR_SHIPPING_COST, STR_SUBMIT, STR_SUCCESS, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_UNIT, STR_UNIT_PRICE, STR_UNPAID } from "../Strings";


export default function OrderReceipt({ data }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	
	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	return (
		<div
			style={{
				width: "100%",
				height: "auto",
				paddingTop: "50px",
				paddingBottom: "50px"
			}}
		>
			<div
				style={{
					maxWidth: "400px",
					margin: "0 auto",
					padding: "10px",
				}}
				className="bg-surface mShadow1"
			>
				

				<div
					style={{
						borderTop: "2px dotted black",
						borderBottom: "2px dotted black",
						padding: "10px"
					}}
				>
					<h6
						style={{
							fontSize: "24px"
						}}
						className="mt-3 mb-3 font-bold text-center"
					>
						{STR_RECEIPT[appContext.language]}
						<br/>
						<span className="text-muted">SOKOBORA</span>
					</h6>

					<h6
						style={{
							fontSize: "14px"
						}}
						className="mt-5"
					>
						{STR_DATE[appContext.language]}: {formatDate(data.dateCreated)}
					</h6>
					<h6
						style={{
							fontSize: "14px"
						}}
					>
						{STR_CUSTOMER_NAME[appContext.language]}: {data.userFullname || "N/A"}
					</h6>
					<h6
						style={{
							fontSize: "14px"
						}}
						className="mb-5"
					>
						{STR_CUSTOMER_PHONE[appContext.language]}: {data.userPhone || "N/A"}
					</h6>

					<table
						className="table table-striped"
					>
						<tbody>
							<tr>
								<td
									style={{
										fontSize: "12px",
									}}
								>
									{STR_TOTAL_ORDER_PRICE[appContext.language]}
								</td>
								<td
									style={{
										fontSize: "14px",
									}}
									className="font-bold"
								>
									{formatMoney(data.totalOrderPrice)} TZS
								</td>
							</tr>

							<tr>
								<td
									style={{
										fontSize: "12px",
									}}
								>
									{STR_TRANSACTION_FEES[appContext.language]}
								</td>
								<td
									style={{
										fontSize: "14px",
									}}
									className="font-bold"
								>
									{formatMoney(data.transactionFees)} TZS
								</td>
							</tr>

							<tr>
								<td
									style={{
										fontSize: "12px",
									}}
								>
									{STR_SHIPPING_COST[appContext.language]}
								</td>
								<td
									style={{
										fontSize: "14px",
									}}
									className="font-bold"
								>
									{formatMoney(data.shippingCost)} TZS
								</td>
							</tr>

							<tr>
								<td
									style={{
										fontSize: "12px",
									}}
								>
									{STR_PACKAGING_COST[appContext.language]}
								</td>
								<td
									style={{
										fontSize: "14px",
									}}
									className="font-bold"
								>
									{formatMoney(data.packagingCost)} TZS
								</td>
							</tr>

							<tr>
								<td
									style={{
										fontSize: "12px",
									}}
								>
									{STR_OVERALL_COST[appContext.language]}
								</td>
								<td
									style={{
										fontSize: "18px",
									}}
									className="font-bold"
								>
									{formatMoney(data.overallCost)} TZS
								</td>
							</tr>

						</tbody>
					</table>

					

					<div
						style={{
							border: "4px solid gray",
							padding: "5px",
							fontSize: "18px",
							textTransform: "uppercase",
							marginTop: "20px",
							marginBottom: "10px"
						}}
						className="text-center text-muted font-bold"
					>
						{data.paymentStatus === 'unpaid' ? STR_UNPAID[appContext.language] : ""}
						{data.paymentStatus === 'fully_paid' ? STR_FULLY_PAID[appContext.language] : ""}
						{data.paymentStatus === 'partially_paid' ? STR_PARTIALLY_PAID[appContext.language] : ""}
					</div>
				</div>
			</div>

		</div>
	)
	
}